import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel } from '../../../../../../core/_base/crud';
import { YeuCauDuyetGia} from '../yeu-cau-duyet-gia-model/yeu-cau-duyet-gia.model';
const API_ROOT_URL = environment.ApiRoot + '/kdyeucauduyetgia';

@Injectable()
export class YeuCauDuyetGiaService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDN$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<YeuCauDuyetGia>(API_ROOT_URL + '/YeuCauDuyetGia_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	insert(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL+'/YeuCauDuyetGia_Insert', item, { headers: httpHeaders });
	}

	edit(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<YeuCauDuyetGia>(API_ROOT_URL+'/YeuCauDuyetGia_Update', item, { headers: httpHeaders });
	}

	detail(YCBG: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams()
		.set("YCDG", YCBG.toString());
		return this.http.get<YeuCauDuyetGia>(API_ROOT_URL+`/YeuCauDuyetGia_Detail`, { headers: httpHeaders, params: params });
	}

	delete(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("Id", item.toString());
		return this.http.get<YeuCauDuyetGia>(API_ROOT_URL+`/YeuCauDuyetGia_Delete`, { headers: httpHeaders, params: params });
	}

	cancel(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("Id", item.toString());
		return this.http.get<YeuCauDuyetGia>(API_ROOT_URL+`/YeuCauDuyetGia_Cancel`, { headers: httpHeaders, params: params });
	}
	
	confirm(item: YeuCauDuyetGia): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<YeuCauDuyetGia>(API_ROOT_URL+`/YeuCauDuyetGia_Confirm`, item,{ headers: httpHeaders });
	}
	confirmDetail(item: YeuCauDuyetGia): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<YeuCauDuyetGia>(API_ROOT_URL+`/YeuCauDuyetGia_Confirm_Detail`, item,{ headers: httpHeaders });
	}
	saveKHFeedback(item: YeuCauDuyetGia): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<YeuCauDuyetGia>(API_ROOT_URL+`/YeuCauDuyetGia_SaveKHFeedback`, item,{ headers: httpHeaders });
	}
	lite(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL+`/YeuCauBaoGia_Lite`, { headers: httpHeaders});
	}

	liteId(id: number, idct): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("Id", id.toString()).set("IdCT", idct.toString());
		return this.http.get<any>(API_ROOT_URL+`/YeuCauBaoGia_LiteId`, { headers: httpHeaders, params: params});
	}

	dropdown(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL+`/YeuCauDuyetGia_Lite`, { headers: httpHeaders});
	}

	DanhSachHangHoa(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL+`/DanhSachHangHoa`, { headers: httpHeaders});
	}

	DanhSachKH(BusinessModel: string): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("BusinessModel", BusinessModel);
		return this.http.get<any>(API_ROOT_URL+`/DanhSachKH`, { headers: httpHeaders, params: params });
	}
	InBaoGia(YCBG: number, type:number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams()
		.set("YCDG", YCBG.toString())
		.set("type", type.toString());
		return this.http.get<YeuCauDuyetGia>(API_ROOT_URL+`/InBaoGia`, { headers: httpHeaders, params: params });
	}

	CheckThoiHanGiuGia(ids: number[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<YeuCauDuyetGia>(API_ROOT_URL + `/YeuCauDuyetGia_CheckThoiHanGiuGia`, ids, { headers: httpHeaders });
	}
}
